//import logo from './logo.svg';
// import Login from './pages/Login';
// //import './App.css';
// import DashBoard from './components/dashboard/DashBoard';
 import { BrowserRouter } from 'react-router-dom';
// import Profile from './components/dashboard/Profile';
// import ChangePwd from './components/dashboard/ChangePwd';
// import AddOrder from './components/orders/AddOrders';
// import DeliveryReport from './components/dashboard/DeliveryReport';
// import AddOrders from './components/orders/AddOrders';
// import AddNew from './components/staffDetails/adminStaff/AddNew';
// import RoleAdd from './components/staffDetails/roles/RoleAdd';
// import RoleList from './components/staffDetails/roles/RoleList';

import AppRoutes from "./routes/AppRoutes";

function App() {
  return (
    <>
      {/* <div class="input-group">
        <input type="text" placeholder="Mobile Number" value="" />
          <i class="fa-solid fa-mobile-screen-button"></i>
      </div>

      <div class="input-group">
        <input type="password" placeholder="Password" />
          <i class="fa-solid fa-lock"></i>
      </div>

      <div class="error">
        Password cannot be blank.
      </div>

      <div class="bottom">

        <label class="remember">
          <input type="checkbox" checked />
          Remember Me
        </label>

        <button type="submit" class="btn">
          Sign in
        </button>

      </div> */}
<BrowserRouter>
{/* <Routes>
  <Route path='/' element={<Login />} />
  <Route path='/dashboard' element={<DashBoard />} />
  <Route path='/profile' element={<Profile/>}/>
  <Route path='/changepassword' element={<ChangePwd/>}/>
  
</Routes> */}
<AppRoutes />
</BrowserRouter>
     
    </>
  );
}

export default App;
